import { render, staticRenderFns } from "./CheckboxFacet.vue?vue&type=template&id=0ee123fc&"
import script from "./CheckboxFacet.vue?vue&type=script&lang=js&"
export * from "./CheckboxFacet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports